import "./MultiRoutePopup.css";

import { memo, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { Popup } from "react-mapbox-gl";
import { makeStyles } from "@mui/styles";
import { palette } from "../../theme/palette";
import {
  multiRoutesPopupLocationSelector,
  multiRoutePopupRoutesSelector,
} from "../../reducers/matrixProfile/selectors";
import { MultiRoutePopupItem } from "./MultiRoutePopupItem";
import { PopUpHeader } from "./PopUpHeader";
import { View } from "../View";

const useStyles = makeStyles({
  popup: {
    borderColor: palette.typography.black.high,
    borderRadius: "6px",
    padding: 0,
    zIndex: "4!important",
  },
  container: {
    width: "170px",
    padding: "10px",
    backgroundColor: palette.typography.black.high,
    color: palette.typography.white.high,
    borderRadius: "5px",
  },
  divider: {
    marginTop: "10px",
    marginBottom: "10px",
    backgroundColor: palette.typography.white.high,
  },
  itemContainer: {
    maxHeight: "150px",
    overflow: "auto",
    marginRight: "-14px",
  },
});

export const MultiRoutePopup = memo(() => {
  const styles = useStyles();
  const { postcode, coordinates } =
    useSelector(multiRoutesPopupLocationSelector) || {};
  const routes = useSelector(multiRoutePopupRoutesSelector);
  const markerHas2Rows = [4, 5, 6].includes(routes.length);

  const ref = useRef(null);

  useEffect(() => {
    if (postcode && coordinates && ref) {
      ref.current.scrollIntoView();
    }
  }, [postcode, coordinates]);

  return (
    <Popup
      coordinates={coordinates}
      anchor={"bottom"}
      offset={markerHas2Rows ? 80 : 50}
      className={styles.popup}
    >
      <View className={styles.container}>
        <PopUpHeader />
        <View className={styles.itemContainer}>
          <div ref={ref} />
          {routes.map((routeCode) => (
            <MultiRoutePopupItem
              key={routeCode}
              routeCode={routeCode}
              postcode={postcode}
            />
          ))}
        </View>
      </View>
    </Popup>
  );
});
